import React from 'react'
import ReactDOM from 'react-dom'
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom"

import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

import * as Sentry from "@sentry/react"
import { BrowserTracing } from "@sentry/tracing"
import Login from './Login/Login'
import Tracings from './Tracings'
import { AuthProvider } from 'react-auth-kit'

Sentry.init({

  environment: process.env.NODE_ENV,
  dsn: process.env.REACT_APP_SENTRY_DSN_CLIENT,
  
  integrations: [new BrowserTracing()],

    /* 
		tracesSampleRate is the rate of transactions (TO DO: define transaction) that Sentry 
		will track in order to monitor the application's performance.
		
		A tracesSampleRate of 1.0 captures 100% of the transactions.  A recommended value
		to use is 0.1 (i.e. 10%).
    */

  tracesSampleRate: 1.0,
})

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Home />,
//   },
//   {
//     path: "/login",
//     element: <Login />,
//   },
//   {
//     path: "/tracings",
//     element: <Tracings />,
//   },
// ])

ReactDOM.render(
  <React.StrictMode>

    <AuthProvider
      authType='cookie'
      authName='_auth'
      cookieDomain={window.location.hostname}
      cookieSecure={window.location.protocol === "https:"}
      >
        <App />
      {/* <RouterProvider router={router} /> */}

    </AuthProvider>

  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
